import React from 'react'
import {Modal} from 'antd';

export const ConfirmModal = ({ visible, modalTitle, handleOk, handleCancel, children }) => (
    <Modal
        title={modalTitle}
        getContainer={null}
        open={visible}
        onCancel={handleCancel}
        onOk={handleOk}
        closable={false}
        destroyOnClose={true} >
      {children}
    </Modal>
)